import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { useListBox, useOption } from '@react-aria/listbox';
import { ZIcon, ZDivider } from '@zanichelli/albe-web-components/react';

const List = styled.ul`
    min-width: 80px;
    overflow: auto;
    list-style: none;
    padding: 0;
    margin: 4px 0;
    outline: none;
`;

const ListItem = styled.li`
    background: var(--color-white);
    color: var(--gray800);
    font-size: 14px;
    line-height: 1.25em;
    padding: 0 8px;
    cursor: pointer;
    outline: none;

    :hover {
        background: var(--gray50);
    }

    ${(props) =>
        props.isFocused &&
        css`
            box-shadow: inset var(--outline);
        `}
`;

const ItemContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: ${(props) => (props.isSelected ? '8px 0 8px 8px' : '8px 8px 8px 8px')};
`;

const Icon = styled(ZIcon)`
    margin-left: 8px;
    fill: var(--blue500);
`;

const ListBox = (props) => {
    const ref = useRef(null);
    const { listBoxRef = ref, state } = props;
    const { listBoxProps } = useListBox(props, state, listBoxRef);

    return (
        <List {...listBoxProps} ref={listBoxRef}>
            {[...state.collection].map((item) => (
                <Option key={`option-${item.key}`} item={item} state={state} />
            ))}
        </List>
    );
};

const Option = ({ item, state }) => {
    const ref = useRef(null);
    const { optionProps, isSelected, isFocused } = useOption(
        {
            key: item.key,
        },
        state,
        ref,
    );

    return (
        <ListItem {...optionProps} ref={ref} isFocused={isFocused} isSelected={isSelected}>
            <ItemContent isSelected={isSelected}>
                {item.rendered}
                {isSelected && <Icon name="checkmark" aria-hidden="true" />}
            </ItemContent>
            {state.collection.lastKey !== item.key && <ZDivider />}
        </ListItem>
    );
};

ListBox.propTypes = {
    listBoxRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.instanceOf(Element) })]),
    state: PropTypes.object,
};

Option.propTypes = {
    item: PropTypes.object,
    state: PropTypes.object,
};

export default ListBox;
